import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects
} from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import {
  exhaustMap,
  takeUntil,
  mergeMap,
  distinctUntilChanged,
  filter
} from "rxjs/operators";
import { RoomActions, RoomLiveViewActions } from "../actions";
import { RoomLiveViewSelectors } from "../selectors";

@Injectable()
export class RoomLiveViewEffects implements OnRunEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store
  ) {}

  autoplayPolicyDisabled$ = createEffect(() =>
    this.store.select(RoomLiveViewSelectors.autoplayPolicyDisabled).pipe(
      distinctUntilChanged(),
      filter((_) => _),
      mergeMap(() => [RoomLiveViewActions.init()])
    )
  );

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomLiveViewActions.init),
      mergeMap(() => [RoomActions.init()])
    )
  );

  destroy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomLiveViewActions.destroy),
      mergeMap(() => [RoomActions.destroy()])
    )
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(RoomLiveViewActions.startEffects),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(this.actions$.pipe(ofType(RoomLiveViewActions.stopEffects)))
        )
      )
    );
  }
}
